import { StyledShortCodeLine } from "./BoxShortCodeLine.styled";

type BoxShortCodeLineProps = {
  shortCode: string;
};

const BoxShortCodeLine = ({ shortCode }: BoxShortCodeLineProps) => (
  <StyledShortCodeLine>
    קוד תיבה: {shortCode}
  </StyledShortCodeLine>
);

export default BoxShortCodeLine;
